import React, { PureComponent } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { ReactSVG } from 'react-svg';

import './Header.scss';

import logo from '../../assets/Ibge-logo.png';

import { CardLink } from '../CardLink/CardLink';
import { ActionLink } from '../ActionLink/ActionLink';
import { Loading } from '../../components/Loading/Loading';
import ShowError from '../../components/ShowError/ShowError';
import { fromEvent, Subscription } from 'rxjs';

export interface HeaderCategoryItemProps {
  text: string;
  icon?: string | Function;
}

export interface HeaderProps {
  loadingVisible?: boolean;
  error?: any;
  region?: string;
  healthRegion?: string;
  healthRegionTooltip?: string;
  uf?: string;
  moreWebsitesLink?: string;
  downloadLink?: string;
  aboutLink?: string;
  categories?: HeaderCategoryItemProps[];
  categorySelected?: string;
  onCategoryItemClick?: (category: string) => void;
}

interface HeaderState {
  fixedMode?: boolean;
}

export class Header extends PureComponent<HeaderProps, HeaderState> {
  private scrollSubscription!: Subscription;

  private firstLineRef = React.createRef<HTMLDivElement>();
  private firstLineFakeRef = React.createRef<HTMLDivElement>();

  constructor(props) {
    super(props);
    this.state = { fixedMode: false };
  }

  componentDidMount() {
    const rootElement = document.getElementById('root')!;
    const handleScroll = () => {
      let fixedMode = !!this.state.fixedMode;
      let newFixedMode: boolean;
      const auxEl = this.firstLineRef.current;
      const auxHeight = auxEl?.clientHeight ?? 0;
      if (auxEl && rootElement.scrollTop > (auxEl.offsetTop + auxHeight)) {
        newFixedMode = true;
      } else {
        newFixedMode = false;
      }

      if (fixedMode !== newFixedMode) {
        const searchContainerFakeEl = this.firstLineFakeRef.current;
        if (searchContainerFakeEl) {
          if (newFixedMode) {
            searchContainerFakeEl.style.height = auxHeight + 'px';
          } else {
            searchContainerFakeEl.style.height = '0px';
          }
        }
        this.setState({ fixedMode: newFixedMode });
      }
    };
    this.scrollSubscription = fromEvent(rootElement, 'scroll').subscribe(e => {
      handleScroll();
    });

    handleScroll();
  }

  componentWillUnmount() {
    this.scrollSubscription?.unsubscribe();
  }

  render() {
    return (
      <header className={'Header' + (this.state.fixedMode ? ' fixed-mode' : '')}>
        <div ref={this.firstLineRef} className='header-box-shadow header-logo-content header-content'>
          <Container fluid>
            <Row>
              <Col lg='7' xl='6' className='margin-gutter-bottom'>
                <Row>
                  <Col xs='12' sm='auto' className='d-flex align-items-center justify-content-center'>
                    <a href='https://www.ibge.gov.br/' target='_blank'>
                      <img className='logo' src={logo} alt='IBGE' />
                    </a>
                  </Col>
                  <Col xs='12' className='d-block d-sm-none margin-gutter-bottom'></Col>
                  <Col
                    xs='12' sm='auto'
                    className='d-flex align-items-center justify-content-center'
                  >
                    <div className='page-title-group'>
                      <span className='page-title'>Painel síntese por município</span>
                      <span className='page-subtitle'>Covid-19</span>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col lg='5' xl='6' className='margin-gutter-bottom d-flex align-items-center justify-content-center'>
                <span className='region-title ml-lg-auto'>{this.props.region}</span>
              </Col>
            </Row>
          </Container>
        </div>
        <div ref={this.firstLineFakeRef}></div>
        <div className='header-info-content header-content'>
          <Container fluid>
            <Row>
              <Col lg='8'>
                <Row>
                  <Col
                    xs='12'
                    md='6'
                    lg='auto'
                    className='margin-gutter-bottom'
                  >
                    <CardLink
                      title='Unidade da Federação'
                      subtitle={this.props.uf}
                      textLink='Veja indicadores da Unidade da Federação'
                      link='./indicadores'
                    />
                  </Col>
                  <Col xs='auto' className='d-none d-lg-block'></Col>
                  <Col
                    xs='12'
                    md='6'
                    lg='auto'
                    className='margin-gutter-bottom'
                  >
                    <CardLink
                      title={'Região de Saúde'}
                      subtitle={
                        this.props.healthRegion
                      }
                      textLink='Veja indicadores da Região'
                      link='./indicadores'
                      tooltip={
                        this.props.healthRegionTooltip
                      }
                    />
                  </Col>
                </Row>
              </Col>
              <Col lg='4'>
                <Row>
                  <Col xs='12'>
                    <div className='inputSearch ml-auto'>
                      <Loading visible={this.props.loadingVisible} />
                      <ShowError error={this.props.error} />

                      <div className='search-container-initial'>
                        <div className='search-content'>
                          <div className='search-box'></div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col
                    xs='12'
                    className='margin-gutter-bottom'
                  >
                    <div className='action-link full-height ml-auto'>
                      <ActionLink text='Mais indicadores' link={this.props.moreWebsitesLink} />
                      <ActionLink
                        text='Baixar'
                        icon='download'
                        link={this.props.downloadLink}
                      />
                      <ActionLink
                        text='Sobre'
                        link={this.props.aboutLink}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
        <div className='header-categories-content header-content header-box-shadow'>
          <Container fluid>
            <Row>
              {this.props.categories?.map((item, index) => {
                let iconAux;
                if (
                  typeof item.icon === 'string' &&
                  item.icon.endsWith('.svg')
                ) {
                  iconAux = (
                    <ReactSVG
                      src={item.icon}
                      wrapper='span'
                      className='category-icon margin-gutter-single-right'
                    />
                  );
                } else if (typeof item.icon === 'function') {
                  iconAux = <item.icon
                    className='category-icon margin-gutter-single-right' />;
                } else {
                  iconAux = '';
                }
                return (
                  <Col
                    key={index.toString()}
                    xs='auto'
                    className='margin-gutter-bottom d-flex align-items-center'
                  >
                    <div
                      className={
                        'btn-category' +
                        (item.text === this.props.categorySelected
                          ? ' active'
                          : '')
                      }
                      onClick={() => {
                        if (this.props.onCategoryItemClick) {
                          this.props.onCategoryItemClick(item.text);
                        }
                      }}
                    >
                      {iconAux} {item.text}
                    </div>
                  </Col>
                );
              })}
            </Row>
          </Container>
        </div>
      </header>
    );
  }
}
